module.exports = "img/photo7.cc4f2a.jpeg";